import { render, staticRenderFns } from "./AlarmSettings.vue?vue&type=template&id=f494a870&scoped=true"
import script from "./AlarmSettings.vue?vue&type=script&lang=js"
export * from "./AlarmSettings.vue?vue&type=script&lang=js"
import style0 from "./AlarmSettings.vue?vue&type=style&index=0&id=f494a870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f494a870",
  null
  
)

export default component.exports